import axios from 'axios'
import formData from 'form-data'
import moment from 'moment'
import { ToggleButton } from 'primereact/togglebutton'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { Col, Label, Row } from 'reactstrap'

import { Dropdown } from 'primereact/dropdown'
import InputGroup from '../../common/InputGroup'

import { ACTIVITY_FOLLOW_UP_NONE, DIRECT_MAIL_ACTIVITIES } from '../../constants/permissions'

import { getDivisionsForCustomSelect } from '../Divisions/redux/DivisionActions'
import { getUsersForCustomSelect, getUsersForCustomSelectByDivision } from '../Users/redux/userActions'
import {
  editEventData,
  editTaskData,
  editSharedNoteData,
  getDueDateTask,
  getUserTasksMonthlyStatistic,
  setInitialTaskData,
  setIsHadMeeting,
  setIsSharedNote,
} from './Redux/taskActions'

import { CustomInputNumber } from '../../common/CustomInputs/CustomInputs'
import CustomSelect from '../../common/CustomReactSelectComponent'
import ReactDatePicker from '../../common/ReactDatePicker/ReactDatePicker'
import { MEETING } from '../../constants/activityTypes'
import { FOLLOW_UP_NEXT_WEEK } from '../../constants/taskConstants'
import { changeExpenseData } from '../Expenses/redux/expenseActions'
import { INSURANCE, LOGISTICS } from '../../constants/divisions'
import { EFFORT_LEVEL, PROSPECT_GRADE } from '../../constants/supportTypes'

const CompleteTaskForm = ({
  userPermissions,
  getUsersForCustomSelect,
  setInitialTaskData,
  dataFromActivity,
  taskData,
  editTaskData,
  getDueDateTask,
  userId,
  userDivision,
  eventData,
  usersForCustomSelect,
  editEventData,
  isOpen,
  getDivisionsForCustomSelect,
  divisions,
  getUsersForCustomSelectByDivision,
  openNextStep,
  errors,
  setIsHadMeeting,
  isHadMeeting,
  isSharedNote,
  editSharedNoteData,
  sharedNoteData,
  setIsSharedNote,
  expenseData,
  changeExpenseData,
  isRfpCustomer,
  toggleIsRfpCustomer,
  isMfpCustomer,
  toggleIsMfpCustomer,
  isCreditAppCustomer,
  toggleIsCreditAppCustomer,
  isOnlineFormCustomer,
  toggleIsOnlineFormCustomer,
  displayButton,
  userMonthlyTaskStatistic,
  getUserTasksMonthlyStatistic,
  setRatingData,
  ratingData,
  contact,
}) => {
  const divisionId = useSelector((state) => state.auth.user.division_id)

  const [userTaskCountByDate, setUserTaskCountByDate] = useState([])
  const [options, setOptions] = useState({ ActivityType: [], NextStep: [], ProspectGrade: [], EffortLevel: [] })
  const [division, setDivision] = useState()
  const [isHadDemo, setIsHadDemo] = useState(false)
  const [isReceiptUploaded, setIsReceiptUploaded] = useState(false)
  const ACTIVITY_SUPPORT_TYPE_ID = 8
  const NEXT_STEP_SUPPORT_TYPE_ID = 9

  useEffect(() => {
    if (divisionId === LOGISTICS || divisionId === INSURANCE) {
      setIsSharedNote(true)
    }
  }, [divisionId])

  useEffect(() => {
    setInitialTaskData(dataFromActivity)
  }, [dataFromActivity])

  useEffect(() => {
    if (userMonthlyTaskStatistic.length) {
      const mappedData = userMonthlyTaskStatistic.map((dayData) => {
        return {
          date: dayData.date,
          value: dayData.count,
        }
      })

      setUserTaskCountByDate(mappedData)
    }
  }, [userMonthlyTaskStatistic])

  useEffect(() => {
    getDivisionsForCustomSelect()
  }, [])

  const handleDemoChange = () => {
    setIsHadDemo(!isHadDemo)
    editTaskData('isDemo', !isHadDemo)
  }

  const handleChange = (e, select) => {
    if (select) {
      if (select === 'nextStepId' && e.id === FOLLOW_UP_NEXT_WEEK) {
        editTaskData(
          'followUpDate',
          moment().add(7, 'days').set({ hours: 17, minute: 0, second: 0 }).format('MM/DD/YYYY HH:mm')
        )
      }
      editTaskData(select, e.id)
      return
    }
    const { name, value } = e.target

    if (name === 'dueDate') {
      getDueDateTask(value)
    }
    editTaskData(name, value)
  }

  const handleChangeTaskDate = (date, name) => {
    const value = date ? moment(date).format('MM/DD/YYYY hh:mm a') : ''
    editTaskData(name, value)
  }

  const handleChangeEventData = (e) => {
    const { name, value } = e.target
    editEventData(name, value)
  }

  const handleChangeEventDate = (date, name) => {
    const value = date ? moment(date).format('MM/DD/YYYY hh:mm a') : ''
    editEventData(name, value)
  }

  const handleChangeSelectEventData = (values, name) => {
    const selectedAttendees = []
    if (values) {
      values.forEach((i) => {
        selectedAttendees.push(i.id || i.value)
      })
    }

    editEventData(name, selectedAttendees)
  }

  const handleSelectChange = (values, event) => {
    const { name } = event
    setRatingData((state) => ({ ...state, [name]: values ? values.value || values.id : null }))
  }

  const handleChangeDivision = ({ id }) => {
    if (!id) {
      getUsersForCustomSelect(1, 'all')
      setDivision(id)
      return
    }
    getUsersForCustomSelectByDivision(id, 'true')
    setDivision(id)
  }

  const setDefaultAssigned = () => {
    editTaskData('assigned', userId)
  }

  const handleCalendarOpen = () => {
    let date = null

    if (taskData.dueDate) {
      date = taskData.dueDate
    }

    getUserTasksMonthlyStatistic(date, userId)
  }

  const handleMonthChange = (date) => {
    getUserTasksMonthlyStatistic(date, userId)
  }

  useEffect(() => {
    const loadData = async () => {
      const response = await axios.get(
        `/support-types/supportTypesForSelects/?types=${ACTIVITY_SUPPORT_TYPE_ID}&types=${NEXT_STEP_SUPPORT_TYPE_ID}&types=${PROSPECT_GRADE}&types=${EFFORT_LEVEL}`
      )
      let options = {}
      response.data.map((i) => {
        return (options[i.name.replace(/\s/g, '')] = i.data)
      })
      if (!userPermissions.includes(DIRECT_MAIL_ACTIVITIES)) {
        options = {
          ...options,
          ['ActivityType']: options.ActivityType.filter((i) => i.name !== 'Direct Mail'),
        }
      }
      if (!userPermissions.includes(ACTIVITY_FOLLOW_UP_NONE)) {
        options = {
          ...options,
          ['NextStep']: options.NextStep.filter((i) => i.name !== 'None'),
        }
      }
      setOptions(options)
    }

    getUsersForCustomSelect(userDivision, 'all')
    setDefaultAssigned()

    loadData()
  }, [])

  const onSelectFile = async (e) => {
    const form = new formData()
    form.append('receipt', e.target.files[0])
    const response = await axios({
      method: 'post',
      url: '/expenses/upload-receipt',
      data: form,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    })
    setIsReceiptUploaded(true)
    changeExpenseData('receiptUrl', response.data.location)
    changeExpenseData('receiptKey', response.data.key)
  }

  const activityDropdownOptions = [
    { name: 'Call', code: 'Call' },
    { name: 'Send Email', code: 'Send Email' },
    { name: 'Send Text', code: 'Send Text' },
  ]

  const changeSubject = (e) => {
    if (typeof e.value === 'object') {
      editTaskData('title', e.value.code)
    } else {
      editTaskData('title', e.value)
    }
  }

  return (
    <>
      {divisionId === LOGISTICS && (
        <Row>
          <Col xs={3}>
            <CustomSelect
              label={'Grade'}
              name={'grade'}
              isClearable
              options={options.ProspectGrade || []}
              defaultValue={ratingData?.grade ?? contact?.contactDivisionData?.grade ?? null}
              onChange={(values, event) => handleSelectChange(values, event)}
            />
          </Col>
          <Col xs={3}>
            <CustomSelect
              label={'Effort Level'}
              name={'effortLevel'}
              isClearable
              options={options.EffortLevel || []}
              defaultValue={ratingData?.effortLevel ?? contact?.contactDivisionData?.effortLevelId ?? null}
              onChange={(values, event) => handleSelectChange(values, event)}
            />
          </Col>
        </Row>
      )}
      <Row className='mt-3'>
        <Col xs={12} md={3} lg={3}>
          <Label>Subject</Label>
          <Dropdown
            value={taskData.title}
            options={activityDropdownOptions}
            placeholder='Subject'
            onChange={changeSubject}
            optionLabel='name'
            editable
            className='custom-dropdown'
          />
        </Col>

        <Col xs={12} md={3} lg={3}>
          <CustomSelect
            isMulti={false}
            label='Next Step'
            placeholder='Next Step'
            onChange={(e) => handleChange(e, 'nextStepId')}
            disabled={isOpen}
            defaultValue={taskData.nextStepId || 0}
            options={options.NextStep}
            errorMess={errors.nextStep ? errors.nextStep : ''}
            invalid={errors.nextStep ? true : false}
          />
        </Col>

        {displayButton.mfp && (
          <Col xs={12} md={2} lg={2}>
            <div className='text-center'>
              <Label>Mexico Freight</Label>
              <div>
                <ToggleButton checked={isMfpCustomer} onChange={() => toggleIsMfpCustomer(!isMfpCustomer)} />
              </div>
            </div>
          </Col>
        )}
        {displayButton.rfp && (
          <Col xs={12} md={2} lg={2}>
            <div className='text-center'>
              <Label>RFP</Label>
              <div>
                <ToggleButton checked={isRfpCustomer} onChange={() => toggleIsRfpCustomer(!isRfpCustomer)} />
              </div>
            </div>
          </Col>
        )}
        {displayButton.creditApp && (
          <Col xs={12} md={2} lg={2}>
            <div className='text-center'>
              <Label>Credit App</Label>
              <div>
                <ToggleButton
                  checked={isCreditAppCustomer}
                  onChange={() => toggleIsCreditAppCustomer(!isCreditAppCustomer)}
                />
              </div>
            </div>
          </Col>
        )}
        {displayButton.onlineForm && (
          <Col xs={12} md={2} lg={2}>
            <div className='text-center'>
              <Label>Online Form</Label>
              <div>
                <ToggleButton
                  checked={isOnlineFormCustomer}
                  onChange={() => toggleIsOnlineFormCustomer(!isOnlineFormCustomer)}
                />
              </div>
            </div>
          </Col>
        )}
        <Col xs={12} md={2} lg={2}>
          <div className='text-center'>
            <Label>Had Demo</Label>
            <div>
              <ToggleButton checked={isHadDemo} onChange={() => handleDemoChange(!isHadDemo)} />
            </div>
          </div>
        </Col>
        <Col xs={12} md={2} lg={2}>
          <div className='text-center'>
            <Label>Had Meeting</Label>
            <div>
              <ToggleButton
                checked={isHadMeeting}
                onChange={() => {
                  openNextStep(MEETING)
                  setIsHadMeeting(!isHadMeeting)
                }}
              />
            </div>
          </div>
        </Col>

        <Col xs={12} md={2} lg={2}>
          <div className='text-center'>
            <Label>Shared Notes</Label>
            <div>
              <ToggleButton checked={isSharedNote} onChange={() => setIsSharedNote(!isSharedNote)} />
            </div>
            {/* Only meaningful once a note is actually being written, so it follows that toggle. */}
            {isSharedNote && (
              <div className='mt-2'>
                <Label>Division only</Label>
                <div>
                  <ToggleButton
                    checked={Boolean(sharedNoteData?.isDivisionOnly)}
                    onChange={() => editSharedNoteData('isDivisionOnly', !sharedNoteData?.isDivisionOnly)}
                  />
                </div>
              </div>
            )}
          </div>
        </Col>

        {/* {isHadMeeting && (
          <Col xs={12} md={3} lg={3}>
          </Col>
        )} */}
      </Row>
      {taskData.nextStepId === FOLLOW_UP_NEXT_WEEK && (
        <Row className='mt-3'>
          <Col md='3'>
            {/* <CustomDataPicker
              placeholder='mm/dd/yyyy'
              disabled={false}
              showTime
              show12Time
              name='followUpDate'
              label='Follow Up Date'
              onChange={handleChange}
              value={taskData.followUpDate}
              errorMess={errors.followUpDate ? errors.followUpDate : ''}
            /> */}

            <ReactDatePicker
              onMonthChange={handleMonthChange}
              onCalendarOpen={handleCalendarOpen}
              selected={taskData.followUpDate ? new Date(taskData.followUpDate) : ''}
              errorMess={errors.followUpDate ? errors.followUpDate : ''}
              onChange={(date) => handleChangeTaskDate(date, 'followUpDate')}
              additionalDayContentData={userTaskCountByDate}
              label='Follow Up Date'
              showTimeSelect
              showTimeInput
              isClearable
            />
          </Col>
        </Row>
      )}
      {isHadMeeting && (
        <>
          <Row className='mt-3'>
            <Col md='3'>
              <InputGroup
                label='Location'
                name='location'
                value={eventData.location}
                onChange={(e) => handleChangeEventData(e)}
              />
            </Col>
            <Col md='3'>
              <CustomInputNumber
                label='Expense'
                name='expense'
                mode='currency'
                minFractionDigits={2}
                maxFractionDigits={2}
                currency='USD'
                value={expenseData.expense}
                onChange={(e) => changeExpenseData('expense', e.target.value)}
                placeholder='0'
              />
            </Col>
            <Col md='4'>
              <InputGroup
                onChange={onSelectFile}
                value={null}
                name='receipt'
                label='Upload Receipt'
                type='file'
                placeholder=''
                className='tesk-file-button'
              />
            </Col>
            <Col md='2 d-flex align-items-end'>
              {isReceiptUploaded && (
                <p className='text-success'>
                  <i className='fas fa-check'></i> Uploaded
                </p>
              )}
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col xs={12} md={3} lg={3}>
              {/* <CustomDataPicker
                placeholder='mm/dd/yyyy'
                disabled={false}
                showTime
                show12Time
                name='meetingStart'
                label='Meeting Start Date/Time'
                onChange={handleChangeEventData}
                value={eventData.meetingStart}
                errorMess={errors.meetingStart ? errors.meetingStart : ''}
              /> */}
              <ReactDatePicker
                selected={eventData.meetingStart ? new Date(eventData.meetingStart) : ''}
                errorMess={errors.meetingStart ? errors.meetingStart : ''}
                onChange={(date) => handleChangeEventDate(date, 'meetingStart')}
                label='Meeting Start Date/Time'
                showTimeSelect
                showTimeInput
                isClearable
                allowedDates={[
                  moment().startOf('day'),
                  moment().subtract(1, 'day').startOf('day'),
                  moment().subtract(2, 'day').startOf('day'),
                ]}
              />
            </Col>
            <Col xs={12} md={3} lg={3}>
              {/* <CustomDataPicker
                placeholder='mm/dd/yyyy'
                disabled={false}
                showTime
                show12Time
                name='meetingEnd'
                label='Meeting End Date/Time'
                onChange={handleChangeEventData}
                value={eventData.meetingEnd}
                errorMess={errors.meetingEnd ? errors.meetingEnd : ''}
              /> */}
              <ReactDatePicker
                selected={eventData.meetingEnd ? new Date(eventData.meetingEnd) : ''}
                errorMess={errors.meetingEnd ? errors.meetingEnd : ''}
                onChange={(date) => handleChangeEventDate(date, 'meetingEnd')}
                label='Meeting End Date/Time'
                showTimeSelect
                showTimeInput
                isClearable
                allowedDates={[
                  moment().startOf('day'),
                  moment().subtract(1, 'day').startOf('day'),
                  moment().subtract(2, 'day').startOf('day'),
                ]}
              />
            </Col>
            <Col xs={12} md={3} lg={3}>
              <CustomSelect
                isMulti
                label='Attendees'
                placeholder='Attendees'
                onChange={(e) => handleChangeSelectEventData(e, 'attendees')}
                defaultValue={eventData.attendees || []}
                options={usersForCustomSelect}
              />
            </Col>
            <Col xs={12} md={3} lg={3}>
              <CustomSelect
                isMulti={false}
                label='Divisions'
                placeholder='Divisions'
                onChange={(e) => handleChangeDivision(e)}
                defaultValue={division}
                options={[{ name: 'All', id: null }, ...divisions]}
              />
            </Col>
          </Row>
        </>
      )}
    </>
  )
}

CompleteTaskForm.propTypes = {
  userPermissions: PropTypes.array.isRequired,
  divisions: PropTypes.array,
  getDivisionsForCustomSelect: PropTypes.func.isRequired,
  getUsersForCustomSelect: PropTypes.func.isRequired,
  usersForCustomSelect: PropTypes.array,
  userId: PropTypes.number.isRequired,
  dataFromActivity: PropTypes.object,
  setInitialTaskData: PropTypes.func.isRequired,
  taskData: PropTypes.object,
  editTaskData: PropTypes.func.isRequired,
  getDueDateTask: PropTypes.func.isRequired,
  userDivision: PropTypes.number.isRequired,
  eventData: PropTypes.object,
  getUsersForCustomSelectByDivision: PropTypes.func.isRequired,
  isRfpCustomer: PropTypes.bool,
  toggleIsRfpCustomer: PropTypes.func,
  isMfpCustomer: PropTypes.bool,
  toggleIsMfpCustomer: PropTypes.func,
  isCreditAppCustomer: PropTypes.bool,
  toggleIsCreditAppCustomer: PropTypes.func,
  isOnlineFormCustomer: PropTypes.bool,
  toggleIsOnlineFormCustomer: PropTypes.func,
  displayButton: PropTypes.object,
  userMonthlyTaskStatistic: PropTypes.array,
  getUserTasksMonthlyStatistic: PropTypes.func,
}

CompleteTaskForm.defaultProps = {
  usersForCustomSelect: [],
  dataFromActivity: {},
  taskData: {},
  eventData: {},
  divisions: [],
}

const mapStateToProps = (state) => {
  return {
    userPermissions: state.auth.user.permissions,
    userId: state.auth.user.userId,
    userDivision: state.auth.user.division_id,
    usersForCustomSelect: state.users.usersForCustomSelect,
    dataFromActivity: state.ClickToCall.dataForActivity,
    taskData: state.Task.data,
    eventData: state.Task.eventData,
    divisions: state.divisions.divisionForSelect,
    isHadMeeting: state.Task.isHadMeeting,
    isSharedNote: state.Task.isSharedNote,
    sharedNoteData: state.Task.sharedNoteData,
    expenseData: state.Expenses.expense,
    errors: state.errors,
    userMonthlyTaskStatistic: state.Task.monthlyStatistic,
  }
}

export default connect(mapStateToProps, {
  getUsersForCustomSelect,
  setInitialTaskData,
  editTaskData,
  editSharedNoteData,
  getDueDateTask,
  editEventData,
  getDivisionsForCustomSelect,
  getUsersForCustomSelectByDivision,
  setIsHadMeeting,
  changeExpenseData,
  setIsSharedNote,
  getUserTasksMonthlyStatistic,
})(CompleteTaskForm)
